import { useState, useEffect } from "react";

let cachedDoctors = null;
let fetchPromise = null;

function fetchAllDoctors() {
  if (cachedDoctors) return Promise.resolve(cachedDoctors);
  if (fetchPromise) return fetchPromise;
  fetchPromise = Promise.all([
    fetch("https://mamshospitals.mamscollege.com/wp-json/wp/v2/doctor?_embed&per_page=100&page=1").then(r => r.json()),
    fetch("https://mamshospitals.mamscollege.com/wp-json/wp/v2/doctor?_embed&per_page=100&page=2").then(r => r.json()),
  ]).then(([p1, p2]) => {
    cachedDoctors = [...p1, ...p2];
    return cachedDoctors;
  });
  return fetchPromise;
}

export default function useDepartmentDoctors(specialties) {
  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    const tags = Array.isArray(specialties) ? specialties : [specialties];
    fetchAllDoctors()
      .then(all =>
        setDoctors(
          all.filter(d =>
            tags.includes(d._embedded?.["wp:term"]?.[0]?.[0]?.name)
          )
        )
      )
      .catch(console.error);
  }, []);

  return doctors;
}
